import React from 'react';
import { Select } from '@duxton-web/ui';

import { DAY_GRID_MONTH, DAY_GRID_WEEK } from '../constants';
import { Text } from '@/common/components';

interface CalendarControlsProps {
  view: string;
  onViewChange: (view: string) => void;
}

export const CalendarControls = ({
  view,
  onViewChange,
}: CalendarControlsProps) => {
  return (
    <>
      <Select
        className="switch-view"
        value={view}
        style={{ width: 100 }}
        onChange={onViewChange}
      >
        <Select.Option value={DAY_GRID_MONTH}>Month</Select.Option>
        <Select.Option value={DAY_GRID_WEEK}>Week</Select.Option>
      </Select>
      <Text
        style={{ position: 'absolute', right: 132, top: 86 }}
        type="secondary"
      >
        Timezone: Singapore Standard Time (GMT+08:00)
      </Text>
    </>
  );
};
